import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import VehicleDetail from "@/pages/VehicleDetail";
import SellCar from "@/pages/SellCar";
import Financing from "@/pages/Financing";
import Contact from "@/pages/Contact";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

// Runtime watchdog: removes the Emergent badge if any external script re-injects it.
function useRemoveEmergentBadge() {
  React.useEffect(() => {
    const purge = () => {
      document
        .querySelectorAll('#emergent-badge, a[href*="utm_source=emergent-badge"], a[href*="emergent.sh"][id*="badge"]')
        .forEach((el) => el.remove());
    };
    purge();
    const observer = new MutationObserver(purge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
}

// Always start a newly navigated page from the top (route change → scroll up).
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function App() {
  useRemoveEmergentBadge();
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="top-right"
          theme="dark"
          richColors
          toastOptions={{
            style: {
              background: "#12121A",
              border: "1px solid rgba(255,255,255,0.10)",
              color: "#fff",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/fahrzeuge" element={<Layout><Inventory /></Layout>} />
          <Route path="/fahrzeuge/:id" element={<Layout><VehicleDetail /></Layout>} />
          <Route path="/fahrzeug-verkaufen" element={<Layout><SellCar /></Layout>} />
          <Route path="/finanzierung" element={<Layout><Financing /></Layout>} />
          <Route path="/kontakt" element={<Layout><Contact /></Layout>} />
          <Route path="/impressum" element={<Layout><Impressum /></Layout>} />
          <Route path="/datenschutz" element={<Layout><Datenschutz /></Layout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Layout><AdminDashboard /></Layout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
